import { render, staticRenderFns } from "./QuestionRectMult.vue?vue&type=template&id=16bf2dfa&scoped=true&"
import script from "./QuestionRectMult.vue?vue&type=script&lang=js&"
export * from "./QuestionRectMult.vue?vue&type=script&lang=js&"
import style0 from "./QuestionRectMult.vue?vue&type=style&index=0&id=16bf2dfa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bf2dfa",
  null
  
)

export default component.exports